import React from 'react';
import { connect } from 'react-redux';
import { Footer, FooterPropsType } from '@beef/smart-kit';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';

import { selectIsMobileView } from 'store/common/mobileView/selectors';
import {
  getFooterDataContent,
} from 'store/common/footer/selectors';

const isDataValid = ({
  blocks,
  mailInput,
  appHeading,
  socialsLinks,
  appButtonsMobile,
  appButtonsDesktop,
  footer,
  international,
  subscribeEmailURL,
  subscribeEmailTextAgreementURL,
}: FooterPropsType['data']) => (
  isArray(blocks) &&
  isObject(mailInput) &&
  isString(appHeading) &&
  isArray(socialsLinks) &&
  isObject(appButtonsMobile) &&
  isObject(appButtonsDesktop) &&
  isObject(footer) &&
  isObject(international) &&
  (isString(subscribeEmailURL) || isUndefined(subscribeEmailURL)) &&
  (isString(subscribeEmailTextAgreementURL) || isUndefined(subscribeEmailTextAgreementURL))
);

/**
 * Same as for header, we do not trust shopfront to properly return footer data
 * so if the data is empty or simply crashes footer somehow,
 * we simply turn it off
 */
const FooterContainer: React.FC<FooterPropsType> = ({ data, isMobileView }) =>
  ((isDataValid(data) && !isMobileView) ? <Footer data={data} /> : null);

const mapStateToProps = state => ({
  data: getFooterDataContent(state),
  isMobileView: selectIsMobileView(state),
});

export default connect(mapStateToProps)(FooterContainer);
